import React, { FC, useMemo } from 'react';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { IModalConfirmProps } from '../types';

type IBgEllipseProps = Pick<IModalConfirmProps, 'size' | 'modalType'>;

export const BgEllipse: FC<IBgEllipseProps> = ({ size, modalType }) => {
  const fill = useMemo(() => {
    switch (modalType) {
      case 'success':
        return '#E6FFFB';
      case 'error':
        return colors.red100;
      default:
        return colors.blue100;
    }
  }, [modalType]);

  const dimensions = useMemo(() => {
    switch (size) {
      case 'small':
        if (modalType?.startsWith('whale')) {
          return {
            width: '420',
            height: '116',
            cx: '214',
            cy: '-31',
            rx: '299',
            ry: '147',
          };
        }
        return {
          width: '400',
          height: '92',
          cx: '200',
          cy: '-154',
          rx: '432',
          ry: '246',
        };
      default:
        return {
          width: '600',
          height: '116',
          cx: '304',
          cy: -'31',
          rx: '389',
          ry: '147',
        };
    }
  }, [size, modalType]);

  return (
    <svg
      width={dimensions.width}
      height={dimensions.height}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <ellipse
        cx={dimensions.cx}
        cy={dimensions.cy}
        rx={dimensions.rx}
        ry={dimensions.ry}
        fill={fill}
      />
    </svg>
  );
};
